export default __webpack_public_path__ + "static/media/priority_inactive_icon.7b896fdb.svg";